<template>
    <div class="c-form-wrap" v-bind:class="ComputedClass">
        <label class="c-form-wrap__field-name">{{label}}</label>
        <div class="c-form-wrap__field-wrap">
            <div class="c-form-wrap__input-wrap">
                <input class="c-form-wrap__input"
                       :type="type"
                       :name="fieldName"
                       :data-vv-name="fieldName"
                       v-mask="mask"
                       v-model="localValue"
                       v-validate="validate"
                       @focus="focus"
                       @focusout="focusOut"
                       v-if="mask">

                <input class="c-form-wrap__input"
                       :type="type"
                       :name="fieldName"
                       :data-vv-name="fieldName"
                       v-model="localValue"
                       v-validate="validate"
                       @focus="focus"
                       @focusout="focusOut"

                       v-else>
            </div>
        </div>
        <span class="c-form-wrap__tooltip">
            <template v-if="isError">
                {{ errors.first(fieldName)}}
            </template>
        </span>
    </div>
</template>

<script>
    import {STATUSES} from '../statuses';

    export default {
        name: "cInputDefault",
        props: {
            value: {},
            label: {},
            validate: {},
            fieldName: {
                required: true
            },
            mask:{
                default: null
            },
            type: {
                default: "text"
            },
        },
        data() {
            return {
                localValue: this.value,
                status: STATUSES.EMPTY
            };
        },
        watch: {
            value(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.localValue = newVal;
                }
            },
            localValue(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$emit("input", newVal);
                }
            }
        },
        methods: {
            onChange(evt) {
                this.localValue = evt.target.value;
                this.$emit("change", this.localValue);
            },
            focus(evt){
                this.status = STATUSES.FOCUS;
            },
            focusOut(evt){
                if( this.isNotEmpty ){
                    this.status = STATUSES.FILLED
                }else{
                    this.status = STATUSES.EMPTY;
                }
            }
        },
        computed: {
            isNotEmpty() {
                return this.localValue.length > 0;
            },
            isEmpty() {
                return this.status === STATUSES.EMPTY;
            },
            isFocus() {
                return this.status === STATUSES.FOCUS;
            },
            isFilled() {
                return this.status === STATUSES.FILLED;
            },
            isError() {
                return this.errors.has(this.fieldName);
            },


            ComputedClass: function() {
                return {
                    "c-form-wrap--empty": this.isEmpty,
                    "c-form-wrap--focus": this.isFocus,
                    "c-form-wrap--filled": this.isFilled || this.isNotEmpty,
                    "c-form-wrap--error": this.isError,
                };
            }
        }
    };
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";

    .c-form-wrap {
        box-sizing: border-box;
        margin: 0 10px 10px;
        text-align: left;
        font-family: $RobotoRegular;
        position: relative;
        &__field-name {
            padding-left: 10px;
            display: block;
            position: absolute;
            font-size: 16px;
            transform: translateY(-50%);
            transition: all ease 0.1s;
            top: 35%;
            line-height: 1.2;
            color: #4a4a4a;
        }
        &__input-wrap {
            position: relative;
            vertical-align: top;
            &::before {
                left: 0;
                content: "";
                height: 1px;
                position: absolute;
                bottom: 0;
                width: 100%;
                z-index: 20;
                background: #979797;
            }
            &::after {
                left: 0;
                content: "";
                height: 2px;
                position: absolute;
                bottom: 0;
                width: 0;
                transition: all ease 0.3s;
                z-index: 21;
                background: $violet;
            }
        }
        &__input {
            background-color: rgba(255, 183, 0, 0.04);
            border: none;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            font-family: $RobotoRegular;
            font-size: 16px;
            padding: 25px 10px 10px 10px;
        }
        &__tooltip {
            font-size: 12px;
            color: #9b9b9b;
            padding-left: 10px;
            line-height: 1.5;
        }
    }

    .c-form-wrap {
        $blockname: &;
        &.c-form-wrap--empty {}

        &.c-form-wrap--focus {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 20%;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: $violet;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::after {
                    left: 0;
                    content: "";
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
        }
        &.c-form-wrap--filled {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 20%;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: $violet;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::after {
                    left: 0;
                    content: "";
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
        }

        &.c-form-wrap--error {
            #{$blockname}__field-name {
                color: $error;
            }
            #{$blockname}__input-wrap {
                &::after {
                    width: 100%;
                    background: $error;
                }
            }
            #{$blockname}__input {
                background-color: rgba(255, 78, 0, 0.12);
            }
            #{$blockname}__tooltip {
                color: $error;
            }
        }
    }
</style>
